export const courseStructure = [
  { 
    day: 1, 
    titleKey: "days.day1_title",  // Будем использовать ключи переводов!
    theoryLink: "https://math.ru/drobi", 
    generator: 'fractionsGenerator', 
    taskCount: 10 
  },
  { 
    day: 2, 
    titleKey: "days.day2_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'geometryGenerator', 
    taskCount: 10 
  },
  { 
    day: 3, 
    titleKey: "days.day3_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'equationsGenerator', 
    taskCount: 10 
  },
  { 
    day: 4, 
    titleKey: "days.day4_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'decimalsGenerator', 
    taskCount: 10 
  },
  { 
    day: 5, 
    titleKey: "days.day5_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'ratiosGenerator', 
    taskCount: 10 
  },
  { 
    day: 6, 
    titleKey: "days.day6_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'coordinatesGenerator', 
    taskCount: 10 
  },
  { 
    day: 7, 
    titleKey: "days.day7_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'commonFractionsGenerator', 
    taskCount: 10 
  },
  { 
    day: 8, 
    titleKey: "days.day8_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'percentagesGenerator', 
    taskCount: 10 
  },
  { 
    day: 9, 
    titleKey: "days.day9_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'areasGenerator', 
    taskCount: 10 
  },
  { 
    day: 10, 
    titleKey: "days.day10_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'volumesGenerator', 
    taskCount: 10 
  },
  { 
    day: 11, 
    titleKey: "days.day11_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'statisticsGenerator', 
    taskCount: 10 
  },
  { 
    day: 12, 
    titleKey: "days.day12_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'wordProblemsGenerator', 
    taskCount: 10 
  },
  { 
    day: 13, 
    titleKey: "days.day13_title",
    theoryLink: "https://math.ru/geometry/6class", 
    generator: 'symmetryGenerator', 
    taskCount: 10 
  },
  {
    day: 14,
    titleKey: "days.day14_title",
    theoryLink: "https://math.ru/repetition",
    generator: 'reviewGenerator',
    taskCount: 15
  }
  // ... все 14 дней
];
